<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import { ref, onValue, set, get } from 'firebase/database'
  import { signInWithCustomToken } from 'firebase/auth'
  // import { getMemberStatus } from '@/api/auth'
  import { getMemberAICredits } from '@/api/aiTutor'
  // import { checkIsMember, checkIsHaveFreeTrial } from '@/utils/memberUtil'
  import { updateHistoryData, initTodayData } from '@/utils/dataUpdateUtil'
  import constants from '@/utils/constants'

  export default {
    data() {
      return {
        i18nMap: constants.i18nMap
      }
    },
    computed: {
      ...Vuex.mapGetters(['token', 'updateTime', 'userLanguage', 'isMember', 'orderID'])
    },
    created() {
      this.changeLang()
      this.init()
    },
    methods: {
      changeLang() {
        let userBrowserLang = navigator.language || navigator.browserLanguage
        let userLang = this.userLanguage || this.i18nMap[userBrowserLang] || 'en'
        this.$store.commit('set_userLanguage', userLang)
      },
      async init() {
        if (this.token) {
          let userInfo = await this.$store.dispatch("validateToken")
          if (userInfo) {
            let fbToken = userInfo.UID_JWT

            await Promise.all([
              signInWithCustomToken(this.auth_core, fbToken),
              signInWithCustomToken(this.auth_srs, fbToken),
              signInWithCustomToken(this.auth_aiTutor, fbToken)
            ])

            // let [ memberStatus ] = await Promise.all([
            //   getMemberStatus(userInfo.UID),
            //   signInWithCustomToken(this.auth_core, fbToken),
            //   signInWithCustomToken(this.auth_srs, fbToken),
            //   signInWithCustomToken(this.auth_aiTutor, fbToken)
            // ])
            
            // this.$store.commit('set_isMember', checkIsMember(memberStatus))
            // this.$store.commit('set_isHaveFreeTrial', checkIsHaveFreeTrial(memberStatus))
            
            this.initUserInfo(userInfo)
            this.initHistoryData(userInfo)
            this.initAICredits(userInfo)
          }
        }
      },
      initUserInfo(userInfo) {
        let userInfoRef = ref(this.db_core, `users_private/${userInfo.UID}/user_info`)
        get(userInfoRef).then((snapshot) => {
          if (!snapshot.exists()) {
            let user_info = {
              email: userInfo.Email,
              login_methods: userInfo.FromType
            }
            set(userInfoRef, user_info)
            this.$store.commit('set_isNewUser', true)
          }
        })
      },
      initHistoryData(userInfo) {
        initTodayData()
        get(ref(this.db_srs, `users_private/${userInfo.UID}/learning_history/last_update_time`)).then((snapshot) => {
          if (snapshot.exists()) {
            let last_update_time = snapshot.val()
            if (this.updateTime !== last_update_time) {
              let recordRef = ref(this.db_srs, `users_private/${userInfo.UID}/learning_history/record`)
              onValue(recordRef, (snapshot) => {
                this.$store.commit('set_historyData', snapshot.val())
                this.$store.commit('set_updateTime', last_update_time)
              })
            }
          } else {
            updateHistoryData(0, 0)
          }
        })
      },
      async initAICredits(userInfo) {
        if (this.isMember) {
          let memberAICredits = await getMemberAICredits(userInfo.UID, this.orderID)
          let { StartDate, ExpiredDate, CreditGrant, CreditConsumed, TokenConsumed } = memberAICredits
          let aiCreditsData = {
            startDate: StartDate,
            expiredDate: ExpiredDate,
            creditGrant: CreditGrant,
            creditConsumed: CreditConsumed,
            tokenConsumed: TokenConsumed
          }
          this.$store.commit('set_aiCreditsData', aiCreditsData)
        } else {
          this.initFreeAICredits(userInfo)
        }
      },
      initFreeAICredits(userInfo) {
        let aiTutorCreditsRef = ref(this.db_aiTutor, `aiTutorCredits/${userInfo.UID}/freeTrailCredits`)
        onValue(aiTutorCreditsRef, (snapshot) => {
          if (snapshot.exists()) {
            let aiCreditsData = snapshot.val()
            if (aiCreditsData.creditGrant === 50) {
              aiCreditsData.creditGrant += 300
              set(aiTutorCreditsRef, aiCreditsData)
              this.$store.commit('set_isNewUser', true)
            }
            this.$store.commit('set_aiCreditsData', aiCreditsData)
          } else {
            let aMonth = 30 * 24 * 3600 * 1000
            let startDate = new Date().getTime()
            let expiredDate = startDate + aMonth
            const defaultFreeTrailCredits = {
              startDate,
              expiredDate,
              creditGrant: 300,
              creditConsumed: 0,
              tokenConsumed: 0
            }
            set(aiTutorCreditsRef, defaultFreeTrailCredits).then(() => {
              this.$store.commit('set_aiCreditsData', defaultFreeTrailCredits)
            })
          }
        })
      }
    }
  }
</script>